import { connect, ConnectedProps } from 'react-redux'
import CustomError from '../../../../../../../../baseComponents/CustomError'
import { ModalLittle } from '../../../../../../../../baseComponents/Modal'
import { LittleModalCreateEditChildrenFirst } from '../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../../../../baseComponents/PermissionChecker/function'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import { FormRender } from '../../../../../../../../forms/FormRenderer/types'
import locations from '../../../../../../../../utils/globals/locations'
import { checkIfCanCreateQuote } from '../../../../../../../../utils/globals/order/order'
import withLoading from '../../../../../../../../utils/hoc/withLoading'
import useCreateSellLogic from '../../../../../../../../utils/hooks/sells/orders/useCreateSellLogic'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../../../utils/reducers'
import { BillingGroupPayload } from '../../../../../../../../utils/reducers/company/billingGroups'
import { WorkingCenterPayload } from '../../../../../../../../utils/reducers/company/workingCenters'
import { CustomerPayload } from '../../../../../../../../utils/reducers/customers/customer'
import { getUserPermissions, getSelectedWorkingCenter } from '../../../../../../../../utils/reducers/getters'
import SearchBarOrderCustomerDeciderComponent from '../../../../../../../../specificComponents/sells/SearchBarOrderCustomerDecider'
import { SellModelTypeExtended } from '../../headers/types'

interface ModalCreateSellOrderProps extends ModalEditComponentProps { }

const ModalCreateSellOrder: React.FC<ModalCreateSellOrderProps> = ({ setOpened, ...rest }) => {
    const { t } = useTwinTranslation()
    const userPermissionsCustomer = getUserPermissions('customer.profile.main')
    if (!permissionCheck(userPermissionsCustomer, 'read')) {
        return <ModalLittle opened={true} setOpened={setOpened}>
            <h2 className='mb-25'>
                <TwinTrans transKey='newOrder'>Nuevo pedido</TwinTrans>
            </h2>
            <CustomError textError={t('noPermissionsToSeeCustomers', 'No tienes permisos para ver los clientes')} />
        </ModalLittle>
    }
    return (
        <ModalCreateSellOrderConnect setOpened={setOpened} {...rest} />
    )
}

type ModalCreateSellOrderAfterPermissionsProps = ModalEditComponentProps & ReduxModalCreateSellOrderConnector & {}

const ModalCreateSellOrderAfterPermissions: React.FC<ModalCreateSellOrderAfterPermissionsProps> = ({ userPermissions, allRowData, workingCenters, customers, billingGroups, ...rest }) => {
    const { t } = useTwinTranslation()
    const workingCenter = getSelectedWorkingCenter()
    const { customerInfo, createSell, extraBillingTypesSell, parseBTOBeforeSubmit, fileInfo, addressFields, myCustomerInfo } = useCreateSellLogic({ customers, baseURL: locations.sellOrderSingle, BillingGroupId: workingCenter?.BillingGroupId })
    const error = checkIfCanCreateQuote(t, workingCenters?.[workingCenter?.id])
    const fields: FormRender<SellModelTypeExtended> = [
        {
            cols: 1,
            elements: [
                ...customerInfo,
                ...myCustomerInfo,
                ...extraBillingTypesSell,
                {
                    name: 'custom_name',
                    label: t('customName', 'Nombre personalizado'),
                    component: 'InputWithLabelMargin',
                },
                {
                    name: 'OrderId',
                    component: 'Custom',
                    render: () => <SearchBarOrderCustomerDeciderComponent translations={{
                        title: t('sellOrder', 'Pedido'),
                        seeText: t('showOrder', 'Ver pedido'),
                        duplicateText: t('duplicateOrderDots', 'Duplicar pedido...')
                    }} baseURL={locations.sellOrderSingle} getDataURL='/api/app/order/sell/sellOrder/getAllSellOrdersComplete' />
                },
                ...fileInfo,
                {
                    name: 'CurrencyId',
                    component: 'InputHidden',
                    value: workingCenter?.CurrencyId
                },
                {
                    name: 'WorkingCenterId',
                    component: 'InputHidden',
                    value: workingCenter?.id
                }
            ],
        },
        ...addressFields,
    ]
    return (
        <LittleModalCreateEditChildrenFirst fields={error ? [] : fields} url={'/api/app/order/sell/sellOrder/createSellOrder'} imagePath={['tmp']} translations={{
            title: t('newOrder', 'Nuevo pedido'),
            button: t('create', 'Crear')
        }} haveButtonPermissions={!error} beforeSubmit={parseBTOBeforeSubmit} {...{ ...rest, onSubmit: createSell }} >
            {error ? <CustomError textError={error} className='mb-10' /> : null}
            {!workingCenters?.[workingCenter?.id]?.dictCounters && !error ? <CustomError className='mb-10' textError={t('notFoundWorkingCenterCounterAndForceCreate', 'No se han encontrado contadores disponibles. Si decide continuar, se generará uno automáticamente.')} /> : null}
        </LittleModalCreateEditChildrenFirst>)
}

const modalCreateSellOrderDispatch = {
    setWorkingCenters: (payload: WorkingCenterPayload) => ({ type: 'CHANGE_WORKINGCENTER', payload }),
    setBillingGroups: (payload: BillingGroupPayload) => ({ type: 'CHANGE_BILLINGGROUP', payload }),
    setCustomers: (payload: CustomerPayload) => ({ type: 'CHANGE_CUSTOMER', payload }),
}
const mapModalCreateSellOrderConnector = (state: AllReduxPayloads) => ({ workingCenters: state.workingCenters, billingGroups: state.billingGroups, customers: state.customers })
const modalCreateSellOrderConnector = connect(mapModalCreateSellOrderConnector, modalCreateSellOrderDispatch)
type ReduxModalCreateSellOrderConnector = ConnectedProps<typeof modalCreateSellOrderConnector>

const modalCreateSellOrderConnectLoading = withLoading(ModalCreateSellOrderAfterPermissions, [{ fetchUrl: '/api/app/customer/getAllCustomers', propName: 'customers', setFunctionName: 'setCustomers' }, { fetchUrl: '/api/app/config/billingGroup/getAllBillingGroupsComplete', propName: 'billingGroups', setFunctionName: 'setBillingGroups', params: { includeRelations: true } }, { fetchUrl: '/api/app/workingCenter/getAllWorkingCentersComplete', propName: 'workingCenters', setFunctionName: 'setWorkingCenters' }])
const ModalCreateSellOrderConnect = modalCreateSellOrderConnector(modalCreateSellOrderConnectLoading)


export default ModalCreateSellOrder